// Banner format definitions (id, label, sub, dimensions, layout)
import { Printer, FileImage, Smartphone } from 'lucide-react';

export const NAVY = '#0e1d3a';
export const GOLD = '#d4af37';
export const CREAM = '#fbf8f1';

export const BANNERS = [
    {
        id: 'panel',
        label: 'Panneau "À vendre"',
        sub: 'A4 paysage · 1748×1240',
        icon: <Printer className="w-4 h-4" />,
        width: 1748,
        height: 1240,
        layout: 'landscape',
    },
    {
        id: 'flyer',
        label: 'Flyer / Carte de visite',
        sub: 'Format carte · 1050×600',
        icon: <FileImage className="w-4 h-4" />,
        width: 1050,
        height: 600,
        layout: 'card',
    },
    {
        id: 'story',
        label: 'Story réseaux sociaux',
        sub: 'Instagram · 1080×1920',
        icon: <Smartphone className="w-4 h-4" />,
        width: 1080,
        height: 1920,
        layout: 'portrait',
    },
];
